import { Component, OnInit, Input, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
// Animations
import { slideInDownAnimation } from '../../app/app.animation';
// Common
import { AngularMaterialService, ErrorParseService, LGEDataService, PermissionsService, IAlmConfiguration } from '../../commons';
// State
import { Store } from '@ngrx/store';
import * as fromAlmConfiguration from './state/alm-configuration.selectors';
import * as AlmConfigurationAction from './state/alm-configuration.actions';
import * as lgeApp from '../../app/state/app.actions';
import { Observable, skipWhile, Subscription } from 'rxjs';

@Component({
    selector: 'alm-configuration-screen',
    templateUrl: 'alm-configuration.template.html',
    styleUrls: ['alm-configuration.scss'],
    animations: [slideInDownAnimation],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AlmConfigurationScreenComponent implements OnInit, OnDestroy {
    @Input() private pending$: Observable<boolean>;
    private pendingSubscription: Subscription;
    private pending: boolean;
    @Input() private error$: Observable<string | null>;
    private errorSubscription: Subscription;
    private error: string | null;
    @Input() private stateData$: Observable<IAlmConfiguration | null>;
    private stateDataSubscription: Subscription;
    private stateData: IAlmConfiguration | null;

    almForm: FormGroup;

    constructor(
        private store: Store<fromAlmConfiguration.State>,
        private ref: ChangeDetectorRef,
        private fb: FormBuilder,
        private ams: AngularMaterialService,
        private errorParse: ErrorParseService,
        private _dataService: LGEDataService,
        private permissionsService: PermissionsService
    ) {
        this.selectState();
        this.createForms();

    }

    ngOnInit() {
        this.startSubscriptions();
        // this._dataService.GetAlmDeatilsByCombination()
        //   .then(data => {
        //     // console.log(data);
        //   });
    }

    // Select state
    private selectState(): void {
        this.pending$ = this.store.select(fromAlmConfiguration.getAlmConfigurationScreenPending);
        this.stateData$ = this.store.select(fromAlmConfiguration.getAlmConfigurationState);
        this.error$ = this.store.select(fromAlmConfiguration.getAlmConfigurationScreenError).pipe(skipWhile(error => error === undefined || error === null || error === ''));
    }

    private displayLoader(pending: boolean): void {
        if (pending) {
            this.ams.showLoader("Loading");
        } else {
            this.ams.closeDialog().then(() => {
                if (this.error !== null && this.error !== undefined && this.error !== '') {
                    this.displayError(this.error);
                }
            });
        }
    }

    private displayError(error: any): void {
        let errorMessage;
        if (this.errorParse.foundKeyWord(error, "CORPCOMMONWS")) {
            errorMessage = this.errorParse.translateCCError(error);
        } else {
            errorMessage = error instanceof Object ? error.message : error;
        }
        this.ams.showAlert("Loading Error", errorMessage);
        this.ams.alert.afterClosed().subscribe(result => {
            this.store.dispatch(new AlmConfigurationAction.AlmConfigurationScreenErrorReset());
        });
    }

    onSubmit() {
        // console.log(this.almForm.value);
        // this._dataService.AlmDetailsIUD(this.almForm.value)
        //     .then(data => {
        //         // console.log(data);
        //     }, error => {
        //         console.error(error);
        //     }
        //     );
    }

    // Create reactive forms
    private createForms(): void {
        this.almForm = this.fb.group({

            almData: this.fb.group({
                0: this.fb.group({
                    111: [{value: true, disabled: true}],
                    112: [{value: false, disabled: true}],
                    113: [{value: false, disabled: true}],
                    121: [{value: true, disabled: true}],
                    122: [{value: false, disabled: true}],
                    123: [{value: false, disabled: true}],
                    131: [{value: true, disabled: true}],
                    132: [{value: false, disabled: true}],
                    133: [{value: false, disabled: true}]
                }),
                1: this.fb.group({
                    211: [{value: false, disabled: true}],
                    212: [{value: true, disabled: true}],
                    213: [{value: false, disabled: true}],
                    221: [{value: false, disabled: true}],
                    222: [{value: true, disabled: true}],
                    223: [{value: false, disabled: true}],
                    231: [{value: false, disabled: true}],
                    232: [{value: true, disabled: true}],
                    233: [{value: false, disabled: true}]
                }),
                2: this.fb.group({
                    311: [{value: true, disabled: true}],
                    312: [{value: true, disabled: true}],
                    313: [{value: true, disabled: true}],
                    321: [{value: true, disabled: true}],
                    322: [{value: true, disabled: true}],
                    323: [{value: true, disabled: true}],
                    331: [{value: true, disabled: true}],
                    332: [{value: true, disabled: true}],
                    333: [{value: true, disabled: true}]
                }),
                3: this.fb.group({
                    411: [{value: false, disabled: true}],
                    412: [{value: false, disabled: true}],
                    413: [{value: false, disabled: true}],
                    421: [{value: true, disabled: true}],
                    422: [{value: true, disabled: true}],
                    423: [{value: true, disabled: true}],
                    431: [{value: true, disabled: true}],
                    432: [{value: true, disabled: true}],
                    433: [{value: true, disabled: true}]
                }),
                4: this.fb.group({
                    511: [{value: false, disabled: true}],
                    512: [{value: false, disabled: true}],
                    513: [{value: false, disabled: true}],
                    521: [{value: true, disabled: true}],
                    522: [{value: true, disabled: true}],
                    523: [{value: true, disabled: true}],
                    531: [{value: true, disabled: true}],
                    532: [{value: true, disabled: true}],
                    533: [{value: true, disabled: true}]
                }),
                5: this.fb.group({
                    611: [{value: false, disabled: true}],
                    612: [{value: false, disabled: true}],
                    613: [{value: false, disabled: true}],
                    621: [{value: false, disabled: true}],
                    622: [{value: false, disabled: true}],
                    623: [{value: false, disabled: true}],
                    631: [{value: true, disabled: true}],
                    632: [{value: true, disabled: true}],
                    633: [{value: true, disabled: true}]
                })

            }),
            deleteIt: ['false']
        })
    }
    // Opens sidenav if on mobile
    public openSidenav(): void {
        this.store.dispatch(new lgeApp.OpenSidenav());
    }
    // Subscribe to state data and mark it for changes
    private startSubscriptions(): void {
        this.pendingSubscription = this.pending$
            .subscribe(data => {
                this.pending = data;
                this.displayLoader(this.pending);
                this.ref.markForCheck();
            });
        this.errorSubscription = this.error$
            .subscribe(data => {
                this.error = data;
                this.ref.markForCheck();
            });
        this.stateDataSubscription = this.stateData$
            .subscribe(data => {
                this.stateData = data;
                this.ref.markForCheck();
            });
    }
    // Unsubscribe from state data changes
    private endSubscriptions(): void {
        this.pendingSubscription.unsubscribe();
        this.errorSubscription.unsubscribe();
        this.stateDataSubscription.unsubscribe();
    }

    ngOnDestroy() {
        this.endSubscriptions();
    }
}





// private createForms(): void {
//     this.almForm = this.fb.group({

//         almData: this.fb.group({
//             0: this.fb.group({
//                 111: [true],
//                 112: [false],
//                 113: [{alse],
//                 121: [true],
//                 122: [false],
//                 123: [false],
//                 131: [true],
//                 132: [false],
//                 133: [false]
//             }),
//             1: this.fb.group({
//                 211: [false],
//                 212: [true],
//                 213: [false],
//                 221: [false],
//                 222: [true],
//                 223: [false],
//                 231: [false],
//                 232: [true],
//                 233: [false]
//             }),
//             2: this.fb.group({
//                 311: [true],
//                 312: [true],
//                 313: [true],
//                 321: [true],
//                 322: [true],
//                 323: [true],
//                 331: [true],
//                 332: [true],
//                 333: [true]
//             }),
//             3: this.fb.group({
//                 411: [false],
//                 412: [false],
//                 413: [false],
//                 421: [true],
//                 422: [true],
//                 423: [true],
//                 431: [true],
//                 432: [true],
//                 433: [true]
//             }),
//             4: this.fb.group({
//                 511: [false],
//                 512: [false],
//                 513: [false],
//                 521: [true],
//                 522: [true],
//                 523: [true],
//                 531: [true],
//                 532: [true],
//                 533: [true]
//             }),
//             5: this.fb.group({
//                 611: [false],
//                 612: [false],
//                 613: [false],
//                 621: [false],
//                 622: [false],
//                 623: [false],
//                 631: [true],
//                 632: [true],
//                 633: [true]
//             })

//         }),
//         deleteIt: ['false']
//     })
// }